module.exports = __webpack_public_path__ + "img/borderCircularAndRightWhite.8e6d5c9b.svg";